
// eslint-disable-next-line import/no-anonymous-default-export
export default async (type, resource, params) => {

    return { type, resource, params };
};